import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Component, signal, viewChild, inject, computed, effect, untracked, Signal } from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { NavigationItems } from '../../models/navigation-item';
import NotificationComponent from './notification/notification';
import Help from './help/help';
import AccountComponent from './account/account';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslatePipe } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AppService } from '../../services/app.service';
import { MenuButton } from '../../models/menu-button.model';
import { ToolbarButton } from '../../models/toolbar-button.type';
import { PermissionType } from '../../models/permission/permission-type-enum';
import { IAuditBaseModel } from '../../../features/audit-trail/models/audit-base-model.model';
import AuditTrail from './audit-trail/audit-trail';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.html',
  styleUrls: ['./sidenav.scss'],
  imports: [
    Help,
    NotificationComponent,
    AccountComponent,
    MatSidenavModule,
    MatListModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    MatIconModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatButtonModule,
    TranslatePipe,
    MatExpansionModule,
    AuditTrail,
  ],
  providers: [
  ]
})
export class Sidenav {
  public readonly leftSidenav = viewChild.required<MatSidenav>('leftSidenav');
  public readonly rightComponent = signal<ToolbarButton | null>(null);
  public readonly menus: Signal<MenuButton[]> = computed(()=>NavigationItems.filter(f=>f.permissions===undefined || this.authService.isAuthorized(f.permissions)()));  
  public readonly busy = computed(() => this.appService.busy());
  public readonly isMobile = signal(false);
  public readonly autitTrail = computed(()=>this.appService.auditTrail() as IAuditBaseModel);
  public readonly accessSetup = computed(() => this.authService.isAuthorized([PermissionType.AccessSetup])());

  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly appService = inject(AppService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly rightSidenav = viewChild.required<MatSidenav>('rightSidenav');

  constructor() {
    this.breakpointObserver.observe(Breakpoints.Handset).subscribe(
      (result: BreakpointState) => this.isMobile.set(result.matches)
    );
    effect(()=> this.openAuditTrail());
  }


  toggleRightMenu(component: ToolbarButton): void {
    if (this.isMobile() && component!=='auditTrail') { // TODO: implement auditTrail component in mobile view
      this.router.navigate([component]);
      return;
    }

    const rightSidenav = this.rightSidenav();

    if (this.rightComponent() === component && rightSidenav.opened) {
      rightSidenav.close();
      this.rightComponent.set(null);
      return;
    }

    this.rightComponent.set(component);
    rightSidenav.open();
  }


  openAuditTrail(): void{
    if(this.appService.auditTrail()!==null){
      untracked(()=> this.toggleRightMenu('auditTrail'));
    }
  }

}
